<a #topOfTable></a>
<ngx-datatable
        #myTable
        style="width: 100%"
        class="material expandable dashboard"
        [rows]="displayRows"
        [columnMode]="'force'"
        [headerHeight]="tableDefinition.hideColumnHeaders ? 0 : -1"
        [footerHeight]="isLoading ? 0 : 50"
        [messages]="isLoading ? {emptyMessage: '', totalMessage:'', selectedMessage: ''} : tableDefinition.messages"
        [limit]="pageSize"
        rowHeight="auto"
        [reorderable]="false"
        [scrollbarH] = "true"
        [rowClass]="tableDefinition.getRowClass"
        [selected]="selections || []"
        [selectionType]="selectionType.checkbox"
        [trackByProp]="tableDefinition.idProperty"
        [sortType]="sortType.multi" [externalSorting]="true" [sorts]="appliedSort" (sort)="onSort($event)"
        (page)="onPageChange($event)"
        (activate)="onRowClick($event)"
        [count]="totalRows ? totalRows : displayRows.length"
        [externalPaging]="externalPaging">

    <!-- Row Detail Template -->
    <ngx-datatable-row-detail
            [rowHeight]="tableDefinition.detailRowHeight">
        <ng-template let-row="row" let-expanded="expanded" ngx-datatable-row-detail-template>
            <ng-template [ngTemplateOutlet]="expandTemplateRef" [ngTemplateOutletContext]="{row: row}"></ng-template>
        </ng-template>
    </ngx-datatable-row-detail>

    <!-- Checkbox column -->
    <ngx-datatable-column
            *ngIf="selections"
            class="header-checkbox"
            [width]="35"
            [sortable]="false"
            [canAutoResize]="false"
            [draggable]="false"
            [resizeable]="false"
            [headerCheckboxable]="true"
            [checkboxable]="true">
        <ng-template ngx-datatable-cell-template let-row="row" let-expanded="expanded" let-value="value" let-isSelected="isSelected">
            <label class="checkbox custom"><input type="checkbox" [checked]="checkSelected(row[tableDefinition.idProperty])" (change)="selectRow(row[tableDefinition.idProperty])"/><span style="left: auto; top: 25%"></span></label>
        </ng-template>
    </ngx-datatable-column>

    <!-- Expander column -->
    <ngx-datatable-column *ngIf="expandTemplateRef"
                          [width]="30"
                          [resizeable]="false"
                          [sortable]="false"
                          [draggable]="false"
                          [canAutoResize]="false">
        <ng-template let-row="row" let-expanded="expanded" ngx-datatable-cell-template>
            <button
                    [class.icon-right]="!expanded"
                    [class.icon-down]="expanded"
                    title="Expand/Collapse Row"
                    style="border: none; outline: none;"
                    (click)="toggleExpandRow(row)">
            </button>
        </ng-template>
    </ngx-datatable-column>
    <!--<ngx-datatable-column *ngIf="!expandTemplateRef"-->
    <!--[width]="30"-->
    <!--[resizeable]="false"-->
    <!--[sortable]="false"-->
    <!--[draggable]="false"-->
    <!--[canAutoResize]="false">-->
    <!--</ngx-datatable-column>-->
    <!-- Data columns -->
    <ngx-datatable-column *ngFor="let colDef of tableDefinition.columns"
                          [name]="colDef.header"
                          [prop]="colDef.property"
                          [width]="colDef.width"
                          [resizeable]="false"
                          [sortable]="colDef.sortable !== false"
                          [cellClass]="colDef.getCellClass">

        <ng-template let-column="column" let-sort="sortFn" ngx-datatable-header-template>
            <!-- Next line may show an IDE error because Angular Language Service isn't smart enough to see that sort is a function -->
            <div  class="line-count-{{tableDefinition.columnHeaderLines||1}} format-{{colDef.format}}"
                  (click)="sort()"
                  [innerHtml]="column.name">
            </div>
                      
            <div class="filter-div" *ngIf="filterRow && colDef.filterable !== false && !colDef.filterCol;
            else useFilter">
                <input type="search"  [(ngModel)]="filterRow[colDef.property]" (keyup)='updateFilter()'>
            </div>

            <ng-template #useFilter>
                <div class="filter-div" *ngIf="filterRow && colDef.filterable !== false && filterRow[colDef.filterCol] 
                !== null">
                    <input type="search"  [(ngModel)]="filterRow[colDef.filterCol]" (keyup)='updateFilter()'>
                </div>
            </ng-template>

        </ng-template>
        <ng-template let-value="value" ngx-datatable-cell-template>
            <div *ngIf="colDef.format==='integer'" class="format-integer">{{value}}</div>
            <div *ngIf="colDef.format==='decimal2'" class="format-decimal2">{{value | number:'.2'}}</div>
            <div *ngIf="colDef.format==='blankZeroDecimal'" class="format-decimal2">{{!value ? '' : value  | number:'.2'}}</div>
            <div *ngIf="colDef.format==='USD'" class="format-USD">{{ (value === null || value === undefined) ? '' : value | currency:'USD':'symbol':'.2'}}</div>
            <div *ngIf="colDef.format==='zeroBlankUSD'" class="format-USD">{{ !value ? '' : value | currency:'USD':'symbol':'.2'}}</div>
            <div *ngIf="colDef.format==='date'" class="format-date">{{value | myDate}}</div>
            <span *ngIf="colDef.format==='datetime'" class="format-datetime">{{value | myDateTime}}</span>
            <span *ngIf="colDef.format==='dateMonthYear'" class="format-date">{{value | myDateMonthYear}}</span>
            <span *ngIf="colDef.format==='html'" [innerHTML]="value"></span>
            <span *ngIf="!colDef.format" [ngClass]="{wordbreak: colDef.wordbreak}">{{value}}</span>
        </ng-template>
    </ngx-datatable-column>

    <!-- Filter toggle -->
    <ngx-datatable-column *ngIf="isFilterable"
                          [width]="24"
                          [resizeable]="false"
                          name="">
        <ng-template let-column="column" ngx-datatable-header-template>
            <div class="filter-toggle" (click)="onToggleFilter()"></div>
        </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-footer
            [totalMessage]="tableDefinition.messages.totalMessage"
            [pagerLeftArrowIcon]="'datatable-icon-left'"
            [pagerRightArrowIcon]="'datatable-icon-right'"
            [pagerPreviousIcon]="'datatable-icon-prev'"
            [selectedMessage]="selectionType && tableDefinition.messages.selectedMessage"
            [pagerNextIcon]="'datatable-icon-skip'">
        <ng-template ngx-datatable-footer-template #myFooterTemplate *ngIf="!hideFooter">
            <div
                    class="datatable-footer-inner"
                    [ngClass]="{'selected-count': tableDefinition.messages.selectedMessage}"
                    [style.height.px]="'footerHeight'">
                <ng-template
                        *ngIf="footerTemplate"
                        [ngTemplateOutlet]="footerTemplate.template"
                        [ngTemplateOutletContext]="{
                                              rowCount: table.rowCount,
                                              pageSize: pageSize,
                                              selectedCount: table.selected.length,
                                              curPage: table.page,
                                              offset: table.offset
                                            }">
                </ng-template>
                <div class="page-count" *ngIf="!footerTemplate">
                    <span *ngIf="tableDefinition.messages.selectedMessage && selections!=null">
                      {{selections.length}} {{tableDefinition.messages.selectedMessage}} /
                    </span>
                    <span *ngIf="tableDefinition.messages.totalMessage && totalDataRows == null">
                      {{totalRows ? totalRows : displayRows.length}} {{tableDefinition.messages.totalMessage}}
                    </span>
                    <span *ngIf="tableDefinition.messages.totalMessage && totalDataRows!=null">
                        <p style="margin:0px">
                            <span *ngIf="totalDataRows > 0">
                                {{getDisplayedRowsCount()}} of
                            </span>
                            {{totalDataRows}} {{tableDefinition.messages.totalMessage}}
                        </p>
                    </span>
                </div>
                <button *ngIf="!hidePager && showMoreLess && pageSize > 5" (click)="showLess()" class="btn btn-primary">Show Less</button>
                <datatable-pager *ngIf="!hidePager"
                                 [pagerLeftArrowIcon]="'icon-left'"
                                 [pagerRightArrowIcon]="'icon-right'"
                                 [pagerPreviousIcon]="'icon-prev'"
                                 [pagerNextIcon]="'icon-skip'"
                                 [page]="page"
                                 [size]="pageSize"
                                 [count]="totalRows ? totalRows : displayRows.length" 
                                 [hidden]="false"
                                 (change)="myTable.onFooterPage($event)">
                </datatable-pager>
                <button *ngIf="hidePager && showMoreLess && pageSize <= 5 && totalRows > 5" (click)="showMore()" class="btn btn-primary">Show More</button>
            </div>
        </ng-template>

    </ngx-datatable-footer>
</ngx-datatable>

<div *ngIf="isLoading" style="width: 100%; height: 128px; background: transparent url('assets/img/loading.gif') no-repeat center center">&nbsp;</div>
